declare global {
	interface Window {
		__aifcDebuggerEnabled__: boolean | undefined;
	}
}

export function log(message: string, ...args: any) {
	if (window.top?.__aifcDebuggerEnabled__) {
		// eslint-disable-next-line no-console
		console.log(`[AIFC]: ${message}`, ...args);
	}
}
